import template from './template.html'

function contabilidadReportesexternosInventarioListaComponent (ReportesexternosInventarios, $moment, $filter, ReportesexternosInventariosCsv, $file) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.recargar = recargar

  $ctrl.buscando = false
  $ctrl.completado = false
  $ctrl.contador = 0
  $ctrl.contadorBusqueda = 0
  $ctrl.limite = 50
  $ctrl.dataDescargado = []

  function $onInit () {
    $ctrl.promise = ReportesexternosInventarios.get($moment($ctrl.busqueda.fechaInicial).format('YYYY-MM-DD'), $moment($ctrl.busqueda.fechaFinal).format('YYYY-MM-DD'), $ctrl.busqueda.sucursales, $ctrl.contador, $ctrl.limite)
      .then(function (response) {
        $ctrl.data = response.data
        $ctrl.dataDescargado = [].concat(response.data)
      })
      .finally(function () {
        $ctrl.contador = $ctrl.contador + $ctrl.limite
      })
  }

  function recargar () {
    if ($ctrl.buscando || $ctrl.dataDescargado.length < $ctrl.limite) return
    $ctrl.buscando = true

    ReportesexternosInventarios.get($moment($ctrl.busqueda.fechaInicial).format('YYYY-MM-DD'), $moment($ctrl.busqueda.fechaFinal).format('YYYY-MM-DD'), $ctrl.busqueda.sucursales, $ctrl.contador, $ctrl.limite)
      .then(function (response) {
        $ctrl.data = $ctrl.data.concat(response.data)
        $ctrl.dataDescargado = [].concat(response.data)
      })
      .finally(function () {
        $ctrl.contador = $ctrl.contador + $ctrl.limite
        $ctrl.buscando = false
      })

  }
}

angular.module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternosInventarioLista', {
    template,
    controller: contabilidadReportesexternosInventarioListaComponent,
    bindings: {
      busqueda: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/inventario/lista/component.js